/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Tibero RDS API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  ApiResponseTiberoParameterDetailResponse,
  GetV7TiberoActiveSessionDetailSqlTextParams,
  GetV7TiberoActiveSessionListParams,
  GetV7TiberoAdditionalDataParams,
  GetV7TiberoLockParams,
  GetV7TiberoParameterDetailByInstanceIdAndParameterNameParams,
  GetV7TiberoPlanSqlIdChildNumberByInstanceIdAndSqlIdAndChildNumberParams,
  GetV7TiberoSessionByInstanceIdAndSidParams,
  GetV7TiberoSqlByIntervalParams,
  GetV7TiberoSqlListByIntervalParams,
  GetV7TiberoSqlListParams,
  LockListV7Response,
  MultiSessionKillResponse,
  MultiSessionTargetForm,
  ParameterListV7Response,
  PostV7TiberoSessionsKillSessionByInstanceIdParams,
  SessionDetailV7Response,
  SessionListV7Response,
  SqlIntervalV7Response,
  SqlListByIntervalV7Response,
  SqlListV7Response,
  SqlPlanV7Response,
  SqlTextBySqlIdV7Response,
  TiberoAdditionalDataResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Tibero SQL Text 조회
 */
export const getV7TiberoActiveSessionDetailSqlText = (
  params: MaybeRef<GetV7TiberoActiveSessionDetailSqlTextParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlTextBySqlIdV7Response>(
    {
      url: `/api/v7/tibero/active-session-detail/sql-text`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7TiberoActiveSessionDetailSqlTextQueryKey = (
  params?: MaybeRef<GetV7TiberoActiveSessionDetailSqlTextParams>,
) => {
  return [
    'api',
    'v7',
    'tibero',
    'active-session-detail',
    'sql-text',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7TiberoActiveSessionDetailSqlTextQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7TiberoActiveSessionDetailSqlText>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7TiberoActiveSessionDetailSqlTextParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7TiberoActiveSessionDetailSqlText>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7TiberoActiveSessionDetailSqlTextQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7TiberoActiveSessionDetailSqlText>>
  > = ({ signal }) => getV7TiberoActiveSessionDetailSqlText(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7TiberoActiveSessionDetailSqlText>>,
    TError,
    TData
  >;
};

export type GetV7TiberoActiveSessionDetailSqlTextQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7TiberoActiveSessionDetailSqlText>>
>;
export type GetV7TiberoActiveSessionDetailSqlTextQueryError = ErrorType<unknown>;

/**
 * @summary Tibero SQL Text 조회
 */

export function useGetV7TiberoActiveSessionDetailSqlText<
  TData = Awaited<ReturnType<typeof getV7TiberoActiveSessionDetailSqlText>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7TiberoActiveSessionDetailSqlTextParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7TiberoActiveSessionDetailSqlText>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7TiberoActiveSessionDetailSqlTextQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * 25.06.04 response tempTablespace, tempMb, usedBlk, logicalReads, physicalReads, dbCpuTime, hashValue 제거 vtrTid, wthrId 추가
26.06.16 isFullText=false: request period/from~toTime 무시하고 수집주기(interval_sec x 1.5) 기반 최신 범위로 조회, isFullText=true: 요청 from~toTime 범위 그대로 조회(엑셀 추출용). 응답 from/to 도 조회 범위와 동일
 * @summary Tibero Active Session 조회
 */
export const getV7TiberoActiveSessionList = (
  params: MaybeRef<GetV7TiberoActiveSessionListParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SessionListV7Response>(
    { url: `/api/v7/tibero/active-session-list`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7TiberoActiveSessionListQueryKey = (
  params?: MaybeRef<GetV7TiberoActiveSessionListParams>,
) => {
  return ['api', 'v7', 'tibero', 'active-session-list', ...(params ? [params] : [])] as const;
};

export const getGetV7TiberoActiveSessionListQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7TiberoActiveSessionList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7TiberoActiveSessionListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7TiberoActiveSessionList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7TiberoActiveSessionListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7TiberoActiveSessionList>>> = ({
    signal,
  }) => getV7TiberoActiveSessionList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7TiberoActiveSessionList>>,
    TError,
    TData
  >;
};

export type GetV7TiberoActiveSessionListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7TiberoActiveSessionList>>
>;
export type GetV7TiberoActiveSessionListQueryError = ErrorType<unknown>;

/**
 * @summary Tibero Active Session 조회
 */

export function useGetV7TiberoActiveSessionList<
  TData = Awaited<ReturnType<typeof getV7TiberoActiveSessionList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7TiberoActiveSessionListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7TiberoActiveSessionList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7TiberoActiveSessionListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Tibero Additional Data 조회
 */
export const getV7TiberoAdditionalData = (
  params: MaybeRef<GetV7TiberoAdditionalDataParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<TiberoAdditionalDataResponse>(
    { url: `/api/v7/tibero/additional-data`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7TiberoAdditionalDataQueryKey = (
  params?: MaybeRef<GetV7TiberoAdditionalDataParams>,
) => {
  return ['api', 'v7', 'tibero', 'additional-data', ...(params ? [params] : [])] as const;
};

export const getGetV7TiberoAdditionalDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7TiberoAdditionalData>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7TiberoAdditionalDataParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7TiberoAdditionalData>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7TiberoAdditionalDataQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7TiberoAdditionalData>>> = ({
    signal,
  }) => getV7TiberoAdditionalData(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7TiberoAdditionalData>>,
    TError,
    TData
  >;
};

export type GetV7TiberoAdditionalDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7TiberoAdditionalData>>
>;
export type GetV7TiberoAdditionalDataQueryError = ErrorType<unknown>;

/**
 * @summary Tibero Additional Data 조회
 */

export function useGetV7TiberoAdditionalData<
  TData = Awaited<ReturnType<typeof getV7TiberoAdditionalData>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7TiberoAdditionalDataParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7TiberoAdditionalData>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7TiberoAdditionalDataQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * 25.06.04 response childNumber 추가
 * @summary Tibero Lock 조회
 */
export const getV7TiberoLock = (
  params: MaybeRef<GetV7TiberoLockParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<LockListV7Response>(
    { url: `/api/v7/tibero/lock`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7TiberoLockQueryKey = (params?: MaybeRef<GetV7TiberoLockParams>) => {
  return ['api', 'v7', 'tibero', 'lock', ...(params ? [params] : [])] as const;
};

export const getGetV7TiberoLockQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7TiberoLock>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7TiberoLockParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7TiberoLock>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7TiberoLockQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7TiberoLock>>> = ({ signal }) =>
    getV7TiberoLock(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7TiberoLock>>,
    TError,
    TData
  >;
};

export type GetV7TiberoLockQueryResult = NonNullable<Awaited<ReturnType<typeof getV7TiberoLock>>>;
export type GetV7TiberoLockQueryError = ErrorType<unknown>;

/**
 * @summary Tibero Lock 조회
 */

export function useGetV7TiberoLock<
  TData = Awaited<ReturnType<typeof getV7TiberoLock>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7TiberoLockParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7TiberoLock>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7TiberoLockQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Tibero Parameter 조회
 */
export const getV7TiberoParameterByInstanceId = (
  instanceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);

  return customAxiosInstance<ParameterListV7Response>(
    { url: `/api/v7/tibero/parameter/${instanceId}`, method: 'GET', signal },
    options,
  );
};

export const getGetV7TiberoParameterByInstanceIdQueryKey = (instanceId?: MaybeRef<string>) => {
  return ['api', 'v7', 'tibero', 'parameter', instanceId] as const;
};

export const getGetV7TiberoParameterByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7TiberoParameterByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7TiberoParameterByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7TiberoParameterByInstanceIdQueryKey(instanceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7TiberoParameterByInstanceId>>> = ({
    signal,
  }) => getV7TiberoParameterByInstanceId(instanceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV7TiberoParameterByInstanceId>>, TError, TData>;
};

export type GetV7TiberoParameterByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7TiberoParameterByInstanceId>>
>;
export type GetV7TiberoParameterByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary Tibero Parameter 조회
 */

export function useGetV7TiberoParameterByInstanceId<
  TData = Awaited<ReturnType<typeof getV7TiberoParameterByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7TiberoParameterByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7TiberoParameterByInstanceIdQueryOptions(instanceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Tibero 세션 멀티킬
 */
export const postV7TiberoSessionsKillSessions = (
  multiSessionTargetForm: MaybeRef<MultiSessionTargetForm[]>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  multiSessionTargetForm = unref(multiSessionTargetForm);

  return customAxiosInstance<MultiSessionKillResponse>(
    {
      url: `/api/v7/tibero/sessions/kill-sessions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: multiSessionTargetForm,
      signal,
    },
    options,
  );
};

export const getPostV7TiberoSessionsKillSessionsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7TiberoSessionsKillSessions>>,
    TError,
    { data: BodyType<MultiSessionTargetForm[]> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7TiberoSessionsKillSessions>>,
  TError,
  { data: BodyType<MultiSessionTargetForm[]> },
  TContext
> => {
  const mutationKey = ['postV7TiberoSessionsKillSessions'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7TiberoSessionsKillSessions>>,
    { data: BodyType<MultiSessionTargetForm[]> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7TiberoSessionsKillSessions(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7TiberoSessionsKillSessionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7TiberoSessionsKillSessions>>
>;
export type PostV7TiberoSessionsKillSessionsMutationBody = BodyType<MultiSessionTargetForm[]>;
export type PostV7TiberoSessionsKillSessionsMutationError = ErrorType<unknown>;

/**
 * @summary Tibero 세션 멀티킬
 */
export const usePostV7TiberoSessionsKillSessions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7TiberoSessionsKillSessions>>,
      TError,
      { data: BodyType<MultiSessionTargetForm[]> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7TiberoSessionsKillSessions>>,
  TError,
  { data: BodyType<MultiSessionTargetForm[]> },
  TContext
> => {
  const mutationOptions = getPostV7TiberoSessionsKillSessionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Tibero sql 추이 조회
 */
export const getV7TiberoSqlByInterval = (
  params: MaybeRef<GetV7TiberoSqlByIntervalParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlIntervalV7Response>(
    { url: `/api/v7/tibero/sql-by-interval`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7TiberoSqlByIntervalQueryKey = (
  params?: MaybeRef<GetV7TiberoSqlByIntervalParams>,
) => {
  return ['api', 'v7', 'tibero', 'sql-by-interval', ...(params ? [params] : [])] as const;
};

export const getGetV7TiberoSqlByIntervalQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7TiberoSqlByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7TiberoSqlByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7TiberoSqlByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7TiberoSqlByIntervalQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7TiberoSqlByInterval>>> = ({
    signal,
  }) => getV7TiberoSqlByInterval(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7TiberoSqlByInterval>>,
    TError,
    TData
  >;
};

export type GetV7TiberoSqlByIntervalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7TiberoSqlByInterval>>
>;
export type GetV7TiberoSqlByIntervalQueryError = ErrorType<unknown>;

/**
 * @summary Tibero sql 추이 조회
 */

export function useGetV7TiberoSqlByInterval<
  TData = Awaited<ReturnType<typeof getV7TiberoSqlByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7TiberoSqlByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7TiberoSqlByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7TiberoSqlByIntervalQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * 25.06.04 response command 제거
 * @summary Tibero SQL 목록 조회
 */
export const getV7TiberoSqlList = (
  params: MaybeRef<GetV7TiberoSqlListParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlListV7Response>(
    { url: `/api/v7/tibero/sql-list`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7TiberoSqlListQueryKey = (params?: MaybeRef<GetV7TiberoSqlListParams>) => {
  return ['api', 'v7', 'tibero', 'sql-list', ...(params ? [params] : [])] as const;
};

export const getGetV7TiberoSqlListQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7TiberoSqlList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7TiberoSqlListParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7TiberoSqlList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7TiberoSqlListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7TiberoSqlList>>> = ({ signal }) =>
    getV7TiberoSqlList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7TiberoSqlList>>,
    TError,
    TData
  >;
};

export type GetV7TiberoSqlListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7TiberoSqlList>>
>;
export type GetV7TiberoSqlListQueryError = ErrorType<unknown>;

/**
 * @summary Tibero SQL 목록 조회
 */

export function useGetV7TiberoSqlList<
  TData = Awaited<ReturnType<typeof getV7TiberoSqlList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7TiberoSqlListParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7TiberoSqlList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7TiberoSqlListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Tibero sql 과거이력 조회
 */
export const getV7TiberoSqlListByInterval = (
  params: MaybeRef<GetV7TiberoSqlListByIntervalParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlListByIntervalV7Response>(
    { url: `/api/v7/tibero/sql-list-by-interval`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7TiberoSqlListByIntervalQueryKey = (
  params?: MaybeRef<GetV7TiberoSqlListByIntervalParams>,
) => {
  return ['api', 'v7', 'tibero', 'sql-list-by-interval', ...(params ? [params] : [])] as const;
};

export const getGetV7TiberoSqlListByIntervalQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7TiberoSqlListByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7TiberoSqlListByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7TiberoSqlListByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7TiberoSqlListByIntervalQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7TiberoSqlListByInterval>>> = ({
    signal,
  }) => getV7TiberoSqlListByInterval(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7TiberoSqlListByInterval>>,
    TError,
    TData
  >;
};

export type GetV7TiberoSqlListByIntervalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7TiberoSqlListByInterval>>
>;
export type GetV7TiberoSqlListByIntervalQueryError = ErrorType<unknown>;

/**
 * @summary Tibero sql 과거이력 조회
 */

export function useGetV7TiberoSqlListByInterval<
  TData = Awaited<ReturnType<typeof getV7TiberoSqlListByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7TiberoSqlListByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7TiberoSqlListByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7TiberoSqlListByIntervalQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Tibero - 파라미터 디테일 (Information과 History 분리)
 */
export const getV7TiberoParameterDetailByInstanceIdAndParameterName = (
  instanceId: MaybeRef<string>,
  parameterName: MaybeRef<string>,
  params: MaybeRef<GetV7TiberoParameterDetailByInstanceIdAndParameterNameParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  parameterName = unref(parameterName);
  params = unref(params);

  return customAxiosInstance<ApiResponseTiberoParameterDetailResponse>(
    {
      url: `/api/v7/tibero/${instanceId}/parameter/${parameterName}/detail`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7TiberoParameterDetailByInstanceIdAndParameterNameQueryKey = (
  instanceId?: MaybeRef<string>,
  parameterName?: MaybeRef<string>,
  params?: MaybeRef<GetV7TiberoParameterDetailByInstanceIdAndParameterNameParams>,
) => {
  return [
    'api',
    'v7',
    'tibero',
    instanceId,
    'parameter',
    parameterName,
    'detail',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7TiberoParameterDetailByInstanceIdAndParameterNameQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7TiberoParameterDetailByInstanceIdAndParameterName>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  parameterName: MaybeRef<string>,
  params: MaybeRef<GetV7TiberoParameterDetailByInstanceIdAndParameterNameParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7TiberoParameterDetailByInstanceIdAndParameterName>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7TiberoParameterDetailByInstanceIdAndParameterNameQueryKey(
    instanceId,
    parameterName,
    params,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7TiberoParameterDetailByInstanceIdAndParameterName>>
  > = ({ signal }) =>
    getV7TiberoParameterDetailByInstanceIdAndParameterName(
      instanceId,
      parameterName,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(instanceId) && unref(parameterName))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7TiberoParameterDetailByInstanceIdAndParameterName>>,
    TError,
    TData
  >;
};

export type GetV7TiberoParameterDetailByInstanceIdAndParameterNameQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7TiberoParameterDetailByInstanceIdAndParameterName>>
>;
export type GetV7TiberoParameterDetailByInstanceIdAndParameterNameQueryError = ErrorType<unknown>;

/**
 * @summary Tibero - 파라미터 디테일 (Information과 History 분리)
 */

export function useGetV7TiberoParameterDetailByInstanceIdAndParameterName<
  TData = Awaited<ReturnType<typeof getV7TiberoParameterDetailByInstanceIdAndParameterName>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  parameterName: MaybeRef<string>,
  params: MaybeRef<GetV7TiberoParameterDetailByInstanceIdAndParameterNameParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7TiberoParameterDetailByInstanceIdAndParameterName>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7TiberoParameterDetailByInstanceIdAndParameterNameQueryOptions(
    instanceId,
    parameterName,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Tibero Plan 조회 (V2)
 */
export const getV7TiberoPlanSqlIdChildNumberByInstanceIdAndSqlIdAndChildNumber = (
  instanceId: MaybeRef<string>,
  sqlId: MaybeRef<string>,
  childNumber: MaybeRef<number>,
  params?: MaybeRef<GetV7TiberoPlanSqlIdChildNumberByInstanceIdAndSqlIdAndChildNumberParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  sqlId = unref(sqlId);
  childNumber = unref(childNumber);
  params = unref(params);

  return customAxiosInstance<SqlPlanV7Response>(
    {
      url: `/api/v7/tibero/${instanceId}/plan/sqlId/${sqlId}/childNumber/${childNumber}`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7TiberoPlanSqlIdChildNumberByInstanceIdAndSqlIdAndChildNumberQueryKey = (
  instanceId?: MaybeRef<string>,
  sqlId?: MaybeRef<string>,
  childNumber?: MaybeRef<number>,
  params?: MaybeRef<GetV7TiberoPlanSqlIdChildNumberByInstanceIdAndSqlIdAndChildNumberParams>,
) => {
  return [
    'api',
    'v7',
    'tibero',
    instanceId,
    'plan',
    'sqlId',
    sqlId,
    'childNumber',
    childNumber,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7TiberoPlanSqlIdChildNumberByInstanceIdAndSqlIdAndChildNumberQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getV7TiberoPlanSqlIdChildNumberByInstanceIdAndSqlIdAndChildNumber>
  >,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  sqlId: MaybeRef<string>,
  childNumber: MaybeRef<number>,
  params?: MaybeRef<GetV7TiberoPlanSqlIdChildNumberByInstanceIdAndSqlIdAndChildNumberParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getV7TiberoPlanSqlIdChildNumberByInstanceIdAndSqlIdAndChildNumber>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7TiberoPlanSqlIdChildNumberByInstanceIdAndSqlIdAndChildNumberQueryKey(
    instanceId,
    sqlId,
    childNumber,
    params,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7TiberoPlanSqlIdChildNumberByInstanceIdAndSqlIdAndChildNumber>>
  > = ({ signal }) =>
    getV7TiberoPlanSqlIdChildNumberByInstanceIdAndSqlIdAndChildNumber(
      instanceId,
      sqlId,
      childNumber,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(instanceId) && unref(sqlId) && unref(childNumber))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7TiberoPlanSqlIdChildNumberByInstanceIdAndSqlIdAndChildNumber>>,
    TError,
    TData
  >;
};

export type GetV7TiberoPlanSqlIdChildNumberByInstanceIdAndSqlIdAndChildNumberQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getV7TiberoPlanSqlIdChildNumberByInstanceIdAndSqlIdAndChildNumber>>
  >;
export type GetV7TiberoPlanSqlIdChildNumberByInstanceIdAndSqlIdAndChildNumberQueryError =
  ErrorType<unknown>;

/**
 * @summary Tibero Plan 조회 (V2)
 */

export function useGetV7TiberoPlanSqlIdChildNumberByInstanceIdAndSqlIdAndChildNumber<
  TData = Awaited<
    ReturnType<typeof getV7TiberoPlanSqlIdChildNumberByInstanceIdAndSqlIdAndChildNumber>
  >,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  sqlId: MaybeRef<string>,
  childNumber: MaybeRef<number>,
  params?: MaybeRef<GetV7TiberoPlanSqlIdChildNumberByInstanceIdAndSqlIdAndChildNumberParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getV7TiberoPlanSqlIdChildNumberByInstanceIdAndSqlIdAndChildNumber>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions =
    getGetV7TiberoPlanSqlIdChildNumberByInstanceIdAndSqlIdAndChildNumberQueryOptions(
      instanceId,
      sqlId,
      childNumber,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * 25.06.04 response tempMb, usedBlk, usedRec, plan_hash_value 제거 vtrTid, wthrId 추가가
 * @summary Tibero > 액티브 세션 탭 > 세션 디테일
 */
export const getV7TiberoSessionByInstanceIdAndSid = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7TiberoSessionByInstanceIdAndSidParams>,
  sid: MaybeRef<number> = 19470,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);
  sid = unref(sid);

  return customAxiosInstance<SessionDetailV7Response>(
    {
      url: `/api/v7/tibero/${instanceId}/session/${sid}`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7TiberoSessionByInstanceIdAndSidQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7TiberoSessionByInstanceIdAndSidParams>,
  sid: MaybeRef<number> = 19470,
) => {
  return ['api', 'v7', 'tibero', instanceId, 'session', sid, ...(params ? [params] : [])] as const;
};

export const getGetV7TiberoSessionByInstanceIdAndSidQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7TiberoSessionByInstanceIdAndSid>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7TiberoSessionByInstanceIdAndSidParams>,
  sid: MaybeRef<number> = 19470,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7TiberoSessionByInstanceIdAndSid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7TiberoSessionByInstanceIdAndSidQueryKey(instanceId, params, sid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7TiberoSessionByInstanceIdAndSid>>
  > = ({ signal }) =>
    getV7TiberoSessionByInstanceIdAndSid(instanceId, params, sid, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(instanceId) && unref(sid))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7TiberoSessionByInstanceIdAndSid>>,
    TError,
    TData
  >;
};

export type GetV7TiberoSessionByInstanceIdAndSidQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7TiberoSessionByInstanceIdAndSid>>
>;
export type GetV7TiberoSessionByInstanceIdAndSidQueryError = ErrorType<unknown>;

/**
 * @summary Tibero > 액티브 세션 탭 > 세션 디테일
 */

export function useGetV7TiberoSessionByInstanceIdAndSid<
  TData = Awaited<ReturnType<typeof getV7TiberoSessionByInstanceIdAndSid>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7TiberoSessionByInstanceIdAndSidParams>,
  sid: MaybeRef<number> = 19470,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7TiberoSessionByInstanceIdAndSid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7TiberoSessionByInstanceIdAndSidQueryOptions(
    instanceId,
    params,
    sid,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Tibero 세션 강제 종료
 */
export const postV7TiberoSessionsKillSessionByInstanceId = (
  params: MaybeRef<PostV7TiberoSessionsKillSessionByInstanceIdParams>,
  instanceId: MaybeRef<string> = '5b81987c-9192-4516-ab70-87c235923445',
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);
  instanceId = unref(instanceId);

  return customAxiosInstance<MultiSessionKillResponse>(
    {
      url: `/api/v7/tibero/${instanceId}/sessions/kill-session`,
      method: 'POST',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV7TiberoSessionsKillSessionByInstanceIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7TiberoSessionsKillSessionByInstanceId>>,
    TError,
    { params: PostV7TiberoSessionsKillSessionByInstanceIdParams; instanceId?: string },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7TiberoSessionsKillSessionByInstanceId>>,
  TError,
  { params: PostV7TiberoSessionsKillSessionByInstanceIdParams; instanceId?: string },
  TContext
> => {
  const mutationKey = ['postV7TiberoSessionsKillSessionByInstanceId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7TiberoSessionsKillSessionByInstanceId>>,
    { params: PostV7TiberoSessionsKillSessionByInstanceIdParams; instanceId?: string }
  > = (props) => {
    const { params, instanceId } = props ?? {};

    return postV7TiberoSessionsKillSessionByInstanceId(params, instanceId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7TiberoSessionsKillSessionByInstanceIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7TiberoSessionsKillSessionByInstanceId>>
>;

export type PostV7TiberoSessionsKillSessionByInstanceIdMutationError = ErrorType<unknown>;

/**
 * @summary Tibero 세션 강제 종료
 */
export const usePostV7TiberoSessionsKillSessionByInstanceId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7TiberoSessionsKillSessionByInstanceId>>,
      TError,
      { params: PostV7TiberoSessionsKillSessionByInstanceIdParams; instanceId?: string },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7TiberoSessionsKillSessionByInstanceId>>,
  TError,
  { params: PostV7TiberoSessionsKillSessionByInstanceIdParams; instanceId?: string },
  TContext
> => {
  const mutationOptions = getPostV7TiberoSessionsKillSessionByInstanceIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
